import _sfc_main from "./FindAnythingButton.vue2.js";
import "./FindAnythingButton.vue3.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FindAnythingButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-83b6710a"]]);
export {
  FindAnythingButton as default
};
//# sourceMappingURL=FindAnythingButton.vue.js.map
